import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VersionCheckService {
  private http = inject(HttpClient);

  // this will be replaced by actual hash post-build.js
  public static readonly codeHash = '{{POST_BUILD_ENTERS_HASH_HERE}}';

  private currentHash: string;

  private versionUpdatedSubject: BehaviorSubject<boolean>;
  public versionUpdated: Observable<boolean>;

  constructor() {
    this.currentHash = VersionCheckService.codeHash;
    this.versionUpdatedSubject = new BehaviorSubject<boolean>(false);
    this.versionUpdated = this.versionUpdatedSubject.asObservable();
  }

  /**
   * Checks in every set frequency the version of frontend application
   */
  public initVersionCheck() {
    if (environment.versionCheckFrequency === 0) {
      // version check disabled
      return;
    }
    // check the version now
    setTimeout(() => {
      this.checkVersion();
    }, 2 * 1000);
    // schedule the next checks
    setInterval(() => {
      this.checkVersion();
    }, environment.versionCheckFrequency * 1000);
  }

  /**
   * Will do the call and check if the hash has changed or not
   */
  private checkVersion() {
    // unncomment for dev test
    // this.versionUpdatedSubject.next(true);
    // timestamp these requests to invalidate caches
    this.http.get<{ hash: string }>(this.getVersionUrl() + '?t=' + new Date().getTime()).subscribe((response) => {
      const hash = response.hash;
      // new version
      if (this.hasHashChanged(this.currentHash, hash)) {
        this.versionUpdatedSubject.next(true);
      }
      // store the new hash so we wouldn't trigger versionChange again
      // only necessary in case you did not force refresh
      this.currentHash = hash;
    });
  }

  /**
   * Checks if hash has changed.
   * This file has the JS hash, if it is a different one than in the version.json
   * we are dealing with version change
   * @param currentHash - the current app hash
   * @param newHash - the new hash
   * @returns - true if the hash has changed
   */
  private hasHashChanged(currentHash, newHash): boolean {
    return currentHash !== newHash;
  }

  private getVersionUrl(): string {
    return window.location.protocol + '//' + window.location.host + '/version.json';
  }
}
